import React, { createContext, useContext } from "react";
import { assets } from "./assets";

const AssetsContext = createContext();

export const AssetsProvider = ({ children }) => (
  <AssetsContext.Provider value={assets}>{children}</AssetsContext.Provider>
);

export const useAssets = () => useContext(AssetsContext);
